import { notificationModule } from "@/store/modules/notification.module"
import { schedulesAggregatorModule } from "@/store/modules/schedules-aggregator.module"
import { TRAINING_TRIGGERED_BY } from "@/types/active-training"
import { NotificationCommand, NotificationType } from "@/types/notification"
import { BaseWorkout, MssHyrox, WorkoutIntensities } from "@/types/workouts"
import { Route, NavigationGuardNext } from "vue-router"
import { appModule } from "@/store/modules/app.module"
import Vue from "vue";
import {convertTimeToString} from "@/utils/string.utils";
import {workoutsModule} from "@/store/modules/workouts.module";
import { mssWorkoutsHyroxModule } from "@/store/modules/mss-workouts-hyrox.module"
import mssWorkoutsHyroxActiveModule from "@/store/modules/mss-workouts-hyrox-active.module"
import {PAGES} from "@/types/router";

export default function beforeEnterMssHyroxActive(to: Route, from: Route, next: NavigationGuardNext<Vue>) {

    const routeArgs = to.params as { id: string; triggeredBy?: TRAINING_TRIGGERED_BY }

    const { id } = routeArgs
    let { triggeredBy } = routeArgs

    if (!triggeredBy) {
        triggeredBy = TRAINING_TRIGGERED_BY.USER
    }

    let workout: MssHyrox
    if (to.name == PAGES.VELOCITY_WORKOUT_ACTIVE) {
        workout = mssWorkoutsHyroxModule.velocityWorkouts.find(workout => {
            return workout.id === id
        }) as MssHyrox
    } else {
        workout = mssWorkoutsHyroxModule.workouts.find(workout => {
            return workout.id === id
        }) as MssHyrox
    }

    if (triggeredBy != TRAINING_TRIGGERED_BY.SCHEDULE) {

        const timeToNearestTraining = schedulesAggregatorModule.timeLeftToTheNextTraining()
        if (timeToNearestTraining) {

            if ((workout as BaseWorkout).totalTime * 1000 > timeToNearestTraining) {
                notificationModule.showNotification({ command: NotificationCommand.SCHEDULED_TRAINING_WILL_START_SOON, type: NotificationType.ALERT })
                return;
            }
        }
    }

    if (workout) {
        const workoutCategory = workoutsModule.workoutFitnessCategories
            .filter(category => category.id == workout.category)[0]?.attributes.name
        mssWorkoutsHyroxActiveModule.init({ workout, triggeredBy })
        appModule.stopContentRefreshing()
        Vue.gtm.trackEvent({
            event: 'svt-workout-mss-start',
            scheduledStart: triggeredBy == TRAINING_TRIGGERED_BY.SCHEDULE,
            workoutName: workout.name,
            workoutDuration: convertTimeToString(workout.totalTime * 1000),
            workoutLevel: WorkoutIntensities.get(workout.difficulty),
            workoutCategory,
        })
        next()
    }
}